import { useMemo } from "react";
import CollectionCard from "./CollectionCard";

// Index position of the big cards
import { jsx as _jsx } from "react/jsx-runtime";
const collectionGridLayout = [0, 5, 6, 11];
const DISPLAY_COUNT = 12;
export function CollectionsGrid(_ref) {
  let {
    data
  } = _ref;
  // Shuffle the collections
  const shuffled = useMemo(() => shuffle(data), [data]);
  return /*#__PURE__*/_jsx("div", {
    className: "md:grid space-y-4 md:space-y-0 md:grid-cols-4 gap-6",
    children: shuffled === null || shuffled === void 0 ? void 0 : shuffled.slice(0, DISPLAY_COUNT).map((collection, i) => {
      const size = collectionGridLayout.includes(i) ? "big" : "small";
      return /*#__PURE__*/_jsx("div", {
        className: size === "big" ? "md:col-span-2" : "",
        children: /*#__PURE__*/_jsx(CollectionCard, {
          collection: collection,
          size: size
        })
      }, collection === null || collection === void 0 ? void 0 : collection.cid);
    })
  });
}

// Random every time the page loads
const SEED = Math.random();
function shuffle(array) {
  const _array = [...array];
  for (let i = _array.length - 1; i > 0; i--) {
    const j = Math.floor(SEED * (i + 1));
    [_array[i], _array[j]] = [_array[j], _array[i]];
  }
  return _array;
}